import { render, staticRenderFns } from "./NewListView.vue?vue&type=template&id=9c3652c2&"
import script from "./NewListView.vue?vue&type=script&lang=js&"
export * from "./NewListView.vue?vue&type=script&lang=js&"
import style0 from "./NewListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports